module.exports = __webpack_public_path__ + "img/num3.45b586ee.png";